// extracted by mini-css-extract-plugin
export default {"block":"a0V8f","offerDoc":"DDQVj"};